module.exports = __webpack_public_path__ + "img/40.3d5a3aae.jpg";